import {
  SET_USER_LOADING,
  SET_USER_ERROR,
  SET_USER
} from "../actionTypes/index";
import { baseUrl } from "../../apis/baseUrl";
import { errorAlert } from "../../helpers/alerts";

const setUser = (payload) => {
  return { type: SET_USER, payload}
}

const setUserError = (payload) => {
  return { type: SET_USER_ERROR, payload };
};

const setUserLoading = (payload) => {
  return { type: SET_USER_LOADING, payload };
};

export const login = (loginData) => {
  return async (dispatch, getState) => {
    dispatch(setUserLoading(true));
    dispatch(setUserError(null));
    try {
      const { data } = await baseUrl.post("/login", loginData);
      return data;
    } catch (err) {
      dispatch(setUserError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setUserLoading(false));
    }
  };
};

export const getProfile = () => {
  return async (dispatch, getState) => {
    dispatch(setUserLoading(true));
    dispatch(setUserError(null));
    try {
      // const { data } = await baseUrl.get("/kenshi/profile", 
      //   {
      //     headers: { access_token: localStorage.access_token },
      //   }
      // );
      // dispatch(setUser(data))
      dispatch(setUser({   
            id: '123',
            email: 'admin@mail.com',
            level: '0',
            position: 'admin',
            role: 'admin'
            }));
    } catch (err) {
      dispatch(setUserError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setUserLoading(false));
    }
  }
}

export const logout = () => {
  return async (dispatch, getState) => {
    dispatch(setUserLoading(true));
    dispatch(setUserError(null));
    try {
      // let id = localStorage.getItem("userId")
      // const { data } = await baseUrl.post(`/users/logout/${id}`, {
      //   headers: {
      //     access_token: localStorage.access_token,
      //   },
      // });
      // return data;
      console.log('logout')
      dispatch(setUser({}));
      return;
    } catch (err) {
      dispatch(setUserError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setUserLoading(false));
    }
  };
};